import { useCallback, useState } from "react";
import { prepareFilterQuery } from "../../components/filter/utils";
import AppAPI from "../api";
import { useAppSelector } from "../store";
import {useTranslation} from "react-i18next";

interface GetDataProps {
  filter?: any;
  page?: number;
}

export default function useTableData() {
  const [loading, setLoading] = useState(false)

  const state = useAppSelector(store => store.AppSlice)
  const [getTableData] = AppAPI.useLazyGetTableDataQuery()
  const { i18n } = useTranslation()

  const getData = useCallback((props?: GetDataProps) => {
    setLoading(true)
    const lang = i18n.language as "ru" | "en"

    const stateProps = {
      filter: props?.filter || prepareFilterQuery(state.filter),
      page: props?.page || state.pagination?.currentPage,
      lang:lang
    }

    getTableData(stateProps).finally(() => setLoading(false))
  }, [getTableData, state.filter, state.pagination?.currentPage])

  return { getData, loading }
}
